import React from 'react'
import { Helmet } from 'react-helmet-async'
import {
  Box,
  Typography,
  Card,
  CardContent,
  Alert
} from '@mui/material'
import { AccountBalance as AccountsIcon } from '@mui/icons-material'
import { generateInspectorTitle } from '../../../contexts/InspectorContext'
import { useInspectorRef } from '../../../hooks/useInspectorRef'

const InspectorAccounts: React.FC = () => {
  const { fpCode: fp_code } = useInspectorRef()

  return (
    <>
      <Helmet>
        <title>{generateInspectorTitle('Accounts')}</title>
      </Helmet>

      <Box>
        <Typography variant="h4" component="h1" gutterBottom sx={{ mb: 3 }}>
          📈 Accounts
        </Typography>

        <Card sx={{ backgroundColor: '#f8f9fa', border: '2px dashed #dee2e6' }}>
          <CardContent sx={{ textAlign: 'center', py: 6 }}>
            <AccountsIcon sx={{ fontSize: '4rem', color: 'text.secondary', mb: 2 }} />
            <Typography variant="h5" gutterBottom>
              Financial Accounts Coming Soon
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
              This section will display financial account information, invoices, 
              and payment data from Xero for {fp_code?.toUpperCase()}.
            </Typography>
            <Alert severity="info" sx={{ maxWidth: '500px', mx: 'auto' }}>
              💳 Features in development: Account balances, invoice tracking, 
              payment history, and Lightspeed-Xero sync validation.
            </Alert>
          </CardContent>
        </Card>
      </Box>
    </>
  )
}

export default InspectorAccounts